export const getUserLanguage = () => 'en';
